"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _ = require("./..");

var _useClassNames2 = require("../../hooks/useClassNames");

var _utils = require("../../../utils");

var formatValue = function formatValue(value) {
  if (value instanceof Array) {
    return value.map(function (date) {
      return (0, _utils.formatDate)(date);
    }).toString();
  } else if (value instanceof Date) {
    return (0, _utils.formatDate)(value);
  } else if (value instanceof Object) {
    if (value.from || value.to) {
      return (value.from ? (0, _utils.formatDate)(value.from) : '') + " - " + (value.to ? (0, _utils.formatDate)(value.to) : '');
    } else {
      return '';
    }
  } else {
    return (0, _utils.formatDate)(value);
  }
};

var parseValue = function parseValue(value, format, _ref) {
  var multiple = _ref.multiple,
      interval = _ref.interval,
      intervalSeparator = _ref.intervalSeparator,
      multipleSeparator = _ref.multipleSeparator;

  if (multiple) {
    var areValidDates = value.split(multipleSeparator).every(function (day) {
      return (0, _utils.isValidStringDate)(day, format);
    });
    return areValidDates && [(0, _utils.parseDate)(value, format)];
  } else if (interval) {
    var _value$split = value.split(intervalSeparator),
        from = _value$split[0],
        to = _value$split[1];

    var isValidInterval = (0, _utils.isValidStringDate)(from, format) && (0, _utils.isValidStringDate)(to, format);
    return isValidInterval && {
      from: (0, _utils.parseDate)(from, format),
      to: (0, _utils.parseDate)(to, format)
    };
  } else {
    var isValidDate = (0, _utils.isValidStringDate)(value, format);
    return isValidDate && (0, _utils.parseDate)(value, format);
  }
};

var checkValue = function checkValue(str, max) {
  if (str.charAt(0) !== '0' || str === '00') {
    var num = parseInt(str);

    if (isNaN(num) || num <= 0 || num > max) {
      num = 1;
    }

    str = num > parseInt(max.toString().charAt(0)) && num.toString().length === 1 ? '0' + num : num.toString();
  }

  return str;
};

var processStringDate = function processStringDate(stringDate, format) {
  var dateFormat = _moment.default.localeData().longDateFormat(format).toLowerCase();

  var dateSeparator = dateFormat[dateFormat.search('[^dmy]')];
  var localeFormatValues = dateFormat.split(dateSeparator);
  var dayIndex = localeFormatValues.indexOf('dd');
  var monthIndex = localeFormatValues.indexOf('mm');
  var values = stringDate.split(dateSeparator).map(function (v) {
    return v.replace(/\D/g, '');
  });

  if (values[monthIndex]) {
    var month = checkValue(values[monthIndex], 12);
    values[monthIndex] = month + (month.length === 2 ? dateSeparator : '');
  }

  if (values[dayIndex]) {
    var day = checkValue(values[dayIndex], 31);
    values[dayIndex] = day + (day.length === 2 ? dateSeparator : '');
  }

  return values.join('');
};

var processStringValue = function processStringValue(value, prevValue, _ref2) {
  var format = _ref2.format,
      multiple = _ref2.multiple,
      interval = _ref2.interval,
      intervalSeparator = _ref2.intervalSeparator,
      multipleSeparator = _ref2.multipleSeparator;

  if (prevValue && prevValue.length > value.length) {
    return value;
  }

  if (interval) {
    return value.split(intervalSeparator).map(function (stringDate, index) {
      var processedStringDate = processStringDate(stringDate, format);
      var firstValue = index === 0;
      var isValid = (0, _utils.isValidStringDate)(processedStringDate, format);
      return processedStringDate + (firstValue && isValid ? intervalSeparator : '');
    }).join('');
  } else if (multiple) {
    return value.split(multipleSeparator).map(function (stringDate, index, _ref3) {
      var length = _ref3.length;
      var processedStringDate = processStringDate(stringDate, format);
      var lastValue = index === length - 1;
      var isValid = (0, _utils.isValidStringDate)(processedStringDate, format);
      return processStringDate(stringDate, format) + (!lastValue && isValid ? multipleSeparator : '');
    }).join('');
  } else {
    return processStringDate(value, format);
  }
};

var DateInput = function DateInput(props) {
  var _useClassNames = (0, _useClassNames2.useClassNames)(props),
      classNames = _useClassNames.classNames,
      className = _useClassNames.className,
      restProps = (0, _objectWithoutPropertiesLoose2.default)(_useClassNames, ["classNames", "className"]);

  var value = restProps.value,
      multiple = restProps.multiple,
      interval = restProps.interval,
      onChange = restProps.onChange,
      onKeyDown = restProps.onKeyDown,
      placeholder = restProps.placeholder,
      multipleSeparator = restProps.multipleSeparator,
      intervalSeparator = restProps.intervalSeparator,
      format = restProps.format,
      moreProps = (0, _objectWithoutPropertiesLoose2.default)(restProps, ["value", "multiple", "interval", "onChange", "onKeyDown", "placeholder", "multipleSeparator", "intervalSeparator", "format"]);
  var inputRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(''),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  var formatedValue = (0, _react.useMemo)(function () {
    if (!value) {
      return inputValue;
    }

    return formatValue(value);
  }, [inputValue, value]);
  var formatedPlaceholder = (0, _react.useMemo)(function () {
    if (placeholder) {
      return placeholder;
    }

    var longDateFormat = _moment.default.localeData().longDateFormat('L').toLowerCase();

    return multiple && "" + longDateFormat + multipleSeparator + longDateFormat + ", ..." || interval && "" + longDateFormat + intervalSeparator + longDateFormat || longDateFormat;
  }, [interval, intervalSeparator, multiple, multipleSeparator, placeholder]);
  var handleChange = (0, _react.useCallback)(function (stringValue, event) {
    if (parseValue(stringValue, format, props)) {
      setInputValue(null);
      onChange(parseValue(stringValue, format, props), event);
    } else {
      var processedStringValue = processStringValue(stringValue, inputValue, props);
      setInputValue(processedStringValue);
      onChange(multiple ? [] : null, event);
    }
  }, [format, inputValue, multiple, onChange, props]);
  var handleKeyDown = (0, _react.useCallback)(function (event) {
    var keyCode = event.which || event.keyCode;
    var stringDate = event.target.value + String.fromCharCode(keyCode);
    var isEscKey = keyCode === 27;

    if (isEscKey) {
      if ((0, _utils.parseDate)(stringDate, format)) {
        setInputValue(null);
        inputRef.current.blur();
      } else {
        onChange(null);
        setInputValue(null);
        inputRef.current.blur();
      }
    }

    onKeyDown(event);
  }, [format, onChange, onKeyDown]);
  return /*#__PURE__*/_react.default.createElement(_.Input, (0, _extends2.default)({
    ref: inputRef,
    className: (classNames() + " " + className).trim(),
    placeholder: formatedPlaceholder,
    value: formatedValue,
    onChange: function onChange(event) {
      return handleChange(event.target.value, event);
    },
    onKeyDown: handleKeyDown
  }, moreProps));
};

DateInput.propTypes = {
  /** Field label */
  label: _propTypes.default.node,
  placeholder: _propTypes.default.string,

  /** Selected day or days. It can be one of the following types:
   - __String__ Formated date string, ie: 'YYYY-MM-DD'. Require set format prop.
   - __Date__ An instance of Date.
   - __Array__ An array of formatted date strings or instances of Date. Require set __multiple__ prop to true.
   - __Object__ An object with from to props as formatted date string or instances of Date. Require set __interval__ prop to true. */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date), _propTypes.default.shape({
    from: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.string]),
    to: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.string])
  }), _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.string]))]),

  /** Callback function fired when day picker value change */
  onChange: _propTypes.default.func,

  /** Callback function fired when key down */
  onKeyDown: _propTypes.default.func,

  /** Callback function fired when input is focused */
  onFocus: _propTypes.default.func,

  /** Callback function fired when input is blured */
  onBlur: _propTypes.default.func,

  /** DateInput string date format */
  format: _propTypes.default.string,

  /** If true, DayPicker allow pick an interval of dates. */
  interval: _propTypes.default.bool,

  /** If true, DayPicker allow pick multiple dates. */
  multiple: _propTypes.default.bool,

  /** Interval separator string uses to render between interval dates */
  intervalSeparator: _propTypes.default.string,

  /** Multiple separator string uses to render between interval dates */
  multipleSeparator: _propTypes.default.string
};
DateInput.defaultProps = {
  alias: 'DateInput',
  intervalSeparator: ' - ',
  multipleSeparator: ', ',
  onKeyDown: _utils.noop,
  onChange: _utils.noop,
  onFocus: _utils.noop,
  onBlur: _utils.noop,
  format: 'L'
};
DateInput.displayName = 'DateInput';
var _default = DateInput;
exports.default = _default;